import { io } from 'socket.io-client'

export default (ctx, inject) => {
	const socket = io(process.env.WEBSOCKET_DOMAIN, {
		query: {},
		autoConnect: false,
		transports: ['websocket'] // use WebSocket first, if available
	})

	const reservationSocket = io(process.env.RESERVATION_WEBSOCKET_DOMAIN, {
		query: {},
		autoConnect: false,
		transports: ['websocket']
	})

	socket.on('connect_error', () => {
		socket.io.opts.transports = ['websocket']
	})

	reservationSocket.on('connect_error', () => {
		reservationSocket.io.opts.transports = ['websocket']
	})

	inject('socket', socket)
	inject('reservationSocket', reservationSocket)
}
